import React from 'react'

export default function Menu() {

    var menuGroups = [
        {
            "GroupName": "Poke Bowls",
            "Items": [
                {
                    "Name": "Custom Poke Bowl",
                    "Description": "",
                    "Price": 13.99
                }, {
                    "Name": "Hawaiian Bowl",
                    "": "",
                    "Price": 13.99
                }, {
                    "Name": "Veggie Poke Bowl",
                    "": "",
                    "Price": 11.99
                }, {
                    "Name": "Teriyaki Bowl",
                    "": "",
                    "Price": 10.99
                }
            ]
        },
        {
            GroupName:"Sushi Rolls",
            Items:[
                {
                    Name: "Dragon Roll",
                    Price:11.99,
                },
                {
                    Name: "Crunchy Dragon Roll",
                    Price:12.99,
                },
                {
                    Name: "California Roll",
                    Price:10.99,
                },
                {
                    Name: "Crunchy California Roll",
                    Price:11.99,
                },{
                    Name: "Chicken Teriyaki Roll",
                    Price:11.99,
                },
                {
                    Name: "Rainbow Roll",
                    Price:13.99,
                },
                {
                    Name: "Shrimp Tempura Roll",
                    Price:13.99,
                },
                {
                    Name: "Philadelphia Roll",
                    Price:13.99,
                },,
                {
                    Name: "Vegetable Roll",
                    Price:10.99,
                },
                {
                    Name: "Cali Inari",
                    Price:11.99,
                },
            ]

        },
        {
            "GroupName": "Appetizers",
            "Items": [
                {
                    "Name": "5 Pc. Tempura & Rice",
                    "": "",
                    "Price": 9.99
                },
                {

                    "Name": "Seaweed Salad",
                    "": "",
                    "Price": 7.99
                },
                {

                    "Name": "Edamame",
                    "": "",
                    "Price": 7.99
                },
                {

                    "Name": "Wonton Noodle Soup",
                    "": "",
                    "Price": 10.99
                },
                {

                    "Name": "Chicken & Vegetable Dumplings",
                    "": "",
                    "Price": 8.99
                },
                {

                    "Name": "Buffalo Wings",
                    "": "",
                    "Price": 8.99
                }

            ]
        },
        {
            GroupName: "Fruit & Root Drinks",
            Items:[
                {Name:"Thai Ice Tea", Price:4.99},
                {Name:"Taro", Price:4.99},
                {Name:"Lychee", Price:1.99},
                {Name:"Mango", Price:2.99},
                {Name:"Pineapple", Price:3.49},
                {Name:"Strawberry", Price:3.49},
                {Name:"Add Boba", Price:"1.00"},
                // {Name:"", Price:1},
                // {Name:"", Price:1},
                // {Name:"", Price:1},
            ]
        },
        {
            GroupName: "Drinks",
            Items:[
                {Name:"Soft Drink", Price:1.99},
                {Name:"Milkis", Price:2.99},
                {Name:"Bai", Price:3.49},
                {Name:"Coconut Water", Price:3.49},
                {Name:"Sparkling Ice", Price:3.29},
                {Name:"Bottled Water", Price:1.49},
            ]
        }

    ]

    function getMenuItem(item) {
        return <>
            <div style={{ alignSelf: 'flex-start', }} >{item.Name}</div>
            <div style={{ flexGrow:1 }} >&nbsp;&nbsp;&nbsp;</div>
            <div style={{ alignSelf: 'flex-end' }} >${item.Price}</div>

        </>
    }

    function getMenuGroup(menuGroup) {
        return (
            <div style={{ width: 500, padding: 20 }}>
                <div style={{ padding:8,borderTop: "1px solid black", borderBottom: "1px solid black", justifyContent: "center", display: "flex", fontSize:36, fontWeight:'bold' }}>
                    {menuGroup.GroupName}
                </div>
                {
                    menuGroup.Items.map((item, index) => {
                        var color = "red"
                        if(index%2 == 1){
                            color = "black"
                        }
                        else{
                            color="black"
                        }
                        return <div style={{ display: 'flex' , fontSize:30, color:color}}>
                            {getMenuItem(item)}
                        </div>

                    })
                }

            </div>
        )
    }

    return (
        <div style={{ width:1400, backgroundColor:"#FCFFDE", display: "flex",  flexWrap: 'wrap' }}>
            {
                menuGroups.map((menuGroup, index) => {
                    return getMenuGroup(menuGroup)
                })
            }
        </div>
    )
}
